import { render, staticRenderFns } from "./PTopMenuTag.vue?vue&type=template&id=625b16a6&scoped=true&"
import script from "./PTopMenuTag.vue?vue&type=script&lang=ts&"
export * from "./PTopMenuTag.vue?vue&type=script&lang=ts&"
import style0 from "./PTopMenuTag.vue?vue&type=style&index=0&id=625b16a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625b16a6",
  null
  
)

export default component.exports